import { localize2WithPath } from '../../../nls.js';
import { Categories } from '../../action/common/actionCommonCategories.js';
import { Action2 } from './actions.js';
import { IMenuService } from './actions.service.js';
import { ILogService } from '../../log/common/log.service.js';
const _moduleId = "vs/platform/actions/common/menuResetAction";
class MenuHiddenStatesReset extends Action2 {
    constructor() {
        super({
            id: 'menu.resetHiddenStates',
            title: ( localize2WithPath(_moduleId, 0, "Reset All Menus")),
            category: Categories.View,
            f1: true
        });
    }
    run(accessor) {
        accessor.get(IMenuService).resetHiddenStates();
        accessor.get(ILogService).info('did RESET all menu hidden states');
    }
}
export { MenuHiddenStatesReset };
